import { CognitoUserSession } from 'amazon-cognito-identity-js'

import { EMPTY_OBJECT } from '../constants/app'

import getCookie from './getCookie'
import isBrowser from './isBrowser'
import toSHA1 from './toSHA1'

declare global {
  interface Window {
    getUserSession?: (hardRefreshOnFailure: boolean) => Promise<any>
  }
}

export default class AuthUtil {
  private static hashedEmail: string

  static getUserHashedEmail = async (): Promise<string | undefined> => {
    if (!isBrowser()) return
    if (AuthUtil.hashedEmail) return AuthUtil.hashedEmail
    const { email } = AuthUtil.getUser()
    if (email) {
      const hashedEmail = await toSHA1(email)
      AuthUtil.hashedEmail = hashedEmail
      return hashedEmail
    }
  }

  static getUser = (): {
    name?: string
    email?: string
  } => {
    if (isBrowser()) {
      const userString = window.localStorage.getItem('gatsbyUser')
      const user = userString ? JSON.parse(userString) : EMPTY_OBJECT
      return user
    }
    return EMPTY_OBJECT
  }

  static isLoggedIn = (): boolean => {
    if (!isBrowser()) return false
    const refreshToken = getCookie('refresh_token')
    if (!refreshToken) {
      return false
    }
    const user = AuthUtil.getUser()
    if (user) return !!user.email
    return false
  }

  static getUserSession = async (hardRefreshOnFailure = false): Promise<CognitoUserSession | undefined> => {
    if (isBrowser() && window.getUserSession) {
      return window.getUserSession(hardRefreshOnFailure)
    }
  }
}
